import DocumentSheduleBody from './DocumentSheduleBody'

export default DocumentSheduleBody;